import React from 'react';
import { QRCode } from '../components/qr-code/QRCode';

export const QRCodePage: React.FC = () => {
  return (
    <div className="page-container">
      <QRCode />
    </div>
  );
};